export const FETCH_EDUCATION_PERIOD_PENDING = 'FETCH_EDUCATION_PERIOD_PENDING'
export const FETCH_EDUCATION_PERIOD_FULFILLED = 'FETCH_EDUCATION_PERIOD_FULFILLED'
export const FETCH_EDUCATION_PERIOD_REJECTED = 'FETCH_EDUCATION_PERIOD_REJECTED'

export const SET_SELECTED_EDUCATION_PERIOD = 'SET_SELECTED_EDUCATION_PERIOD'
export const SET_SELECTED_IS_CURRENT_EDUCATION_PERIOD = 'SET_SELECTED_IS_CURRENT_EDUCATION_PERIOD'
export const CLEAR_SELECTED_EDUCATION_PERIOD = 'CLEAR_SELECTED_EDUCATION_PERIOD'

export const FETCH_ALLOWED_SSD_MATERIALS_PENDING = 'FETCH_ALLOWED_SSD_MATERIALS_PENDING'
export const FETCH_ALLOWED_SSD_MATERIALS_FULFILLED = 'FETCH_ALLOWED_SSD_MATERIALS_FULFILLED'
export const FETCH_ALLOWED_SSD_MATERIALS_REJECTED = 'FETCH_EDUCATION_PERIOD_REJECTED'

export const FETCH_CONTACT_INFORMATION_PENDING = 'FETCH_CONTACT_INFORMATION_PENDING'
export const FETCH_CONTACT_INFORMATION_FULFILLED = 'FETCH_CONTACT_INFORMATION_FULFILLED'
export const FETCH_CONTACT_INFORMATION_REJECTED = 'FETCH_CONTACT_INFORMATION_REJECTED'

export const FETCH_EXAM_WINDOWS = 'FETCH_EXAM_WINDOWS'

export const PAPER_EXAM = 'PAPER'
export const DIGITAL_EXAM = 'DIGITAL'
export const HYBRID_EXAM = 'HYBRID'
